import React, { useState } from 'react'
import Footer from './Footer';
import Navbar from './Navbar';
import Pages from './Pages';
import Header from './Header';
import NavBarReact from './NavBarPrime';
import NewNav from './NewNav';
import { useMediaQuery } from 'react-responsive';







const Layout = () => {

  const [isMenuCollapsed, setisMenuCollapsed] = useState({
    home: false,
    unprocessed: false,
    processed: false,
    reports: false,
    posts: false,
    about: false,
    settings:false
  });

  const isMobile = useMediaQuery({ query: '(max-width: 969px)' })


  return (
    <div className='Layout'>
{/* 
      <Navbar
        isMenuCollapsed = {isMenuCollapsed}
        setisMenuCollapsed = {setisMenuCollapsed}
       /> */}

     

      {/* <NavBarReact /> */}
      {!isMobile && <NewNav /> }
    

      <Header />
      <Pages/>
      <Footer />
    </div>
  )
}

export default Layout